import React, { useState, useEffect } from "react";
import googleLogo from "../assets/images/google-logo.png"
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Button,
  Paper,
  Rating,
  Avatar,
} from '@mui/material';
import Slider from "react-slick";
// import { googleReviews } from "../assets/Json/staticData";
import ReviewDetails from "./ReviewDetails";
import { fetchReviews } from "../store/googleReviews/googleReviewBaseApi";
import { useDispatch, useSelector } from "react-redux";

const ProductCarousel = () => {
  const { reviews, status, error } = useSelector((state) => state.reviews);
  const [open,setOpen] = useState(false);
  const [reviewDetails,setReviewDetails] = useState();
  const [googleReviews,setGoogleReviews] = useState([]);

var settings = {
  dots: true,
  infinite: googleReviews?.length > 3,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 4,
  initialSlide: 0,
  autoplay: googleReviews?.length > 3,
  autoplaySpeed: 2000,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        // dots: true
      }
    },
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};
    
      useEffect(()=>{
        setGoogleReviews(reviews)
      },[reviews])
  
   async function stringToColor(string) {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string?.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }
  
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        // bgcolor:'red',
        height:50,
        width:50,
        fontSize:"20px",
        // color:"white"
      },
      children: <Typography sx={{ fontSize: "28px" }}>
      {name?.charAt(0)?.toUpperCase()}
    </Typography>,
    };
  }
  
  const handleReviewDetails = (review)=>{
    if(open){
      setReviewDetails({})
        setOpen(false)
    }else{
      setReviewDetails(review)
        setOpen(true)
    }
  }
  return (
    // <div>dfdsf</div>
    <Box sx={{width:"100%"}}>

      <Slider {...settings}>
      {
            googleReviews?.map((data,idx)=>{
              return(
                <div key={idx} className=" p-4">
                  
                  
                      <div
                        sx={{
                          // background: 'linear-gradient(90deg, #2d9cdb, #56ccf2)',
                          // minHeight: '100vh',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          // padding: 2,
                          position: 'relative',
                          overflow: 'hidden',
                        }}
                      >
      {/* Background decorations */}
    
    

      {/* Feedback Card */}
      <Card
        sx={{
          width: "auto",
          height:"230px",
          borderRadius: 4,
          boxShadow: 5,
          // textAlign: 'center',
          padding: 2,
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Profile Picture */}
        {/* <Avatar
          src={googleLogo}
          alt="Customer"
          sx={{
            width: 80,
            height: 80,
            margin: '0 auto',
            marginBottom: 2,
          }}
        /> */}
             <div className="d-flex justify-content-between">
                      <div className="d-flex bd-highlight  align-items-center">
                        {/* Avatar */}
                        <div className="p-2 bd-highlight">
                          <Avatar {...stringAvatar(data?.name)} />
                        </div>

                        {/* Name + Rating */}
                        <div className="p-2 bd-highlight">
                          <Typography variant="p" fontWeight="bold" gutterBottom padding="5px">
                            {data?.name}
                          </Typography>
                          <div>
                              <Rating name="read-only" value={data?.star} size="small"  readOnly />
                          </div>
                        </div>

                        {/* Push the logo to the right */}
                        
                      </div>
                      <div>
                      <div className="ml-auto bd-highlight p-4">
                          <img
                            src={googleLogo}
                            alt="best architects in tirunelveli"
                            style={{
                              width: 30,
                              height: 30
                            }}
                          />
                        </div>
                      </div>
             </div>
        {/* <div class="d-flex bd-highlight mb-3">
  <div class="p-2 bd-highlight">Flex item</div>
  <div class="p-2 bd-highlight">Flex item</div>
  <div class="ml-auto p-2 bd-highlight">Flex item</div>
</div> */}

        {/* Feedback Title */}
    

        {/* Rating */}
       

        {/* Feedback Text */}
        <CardContent className="text-center">
          <Typography variant="body2" color="textSecondary" gutterBottom className="truncated-text">
            {data?.review}
          </Typography>
          <p className="reviewMore" onClick={() => handleReviewDetails(data)}>Read More...</p>
        </CardContent>

        {/* Customer Name */}
        {/* <Typography variant="subtitle2" fontWeight="bold">
          CUSTOMER NAME
        </Typography> */}
      </Card>
    </div>
                  
                </div>
              )
            })
          }
      </Slider>
      <ReviewDetails open={open} setOpen={setOpen} handleOpen={handleReviewDetails} review={reviewDetails}/>
    </Box>
  );
};

export default ProductCarousel;
